const GUEST_COUNT_RANGES = [
	{ min: 0, max: 50, label: '0–50' },
	{ min: 51, max: 100, label: '51–100' },
	{ min: 101, max: 150, label: '101–150' },
	{ min: 151, max: 200, label: '151–200' },
	{ min: 201, max: 300, label: '201–300' },
	{ min: 301, label: '300+' },
];

export const guestCountToRange = (guestCount: number): string => {
	const range = GUEST_COUNT_RANGES.find(
		({ min, max }) =>
			guestCount >= min && (max === undefined || guestCount <= max),
	);
	return range?.label ?? '300+';
};

export const guestCountFromRange = (
	range: string | null | undefined,
): string => {
	if (!range) return '';
	const normalized = range.trim();
	const found = GUEST_COUNT_RANGES.find(({ label }) => label === normalized);
	if (found) {
		const mid =
			found.max !== undefined
				? Math.round((found.min + found.max) / 2)
				: found.min;
		return String(mid);
	}
	// fallback for unknown range formats (e.g. '101-150' with hyphen, '44 - 55' with spaces, or plain number)
	const rangeMatch = normalized.match(/^(\d+)\s*[–-]\s*(\d+)$/);
	if (rangeMatch)
		return String(
			Math.round((Number(rangeMatch[1]) + Number(rangeMatch[2])) / 2),
		);
	const plusMatch = normalized.match(/^(\d+)\+$/);
	if (plusMatch) return plusMatch[1];
	if (/^\d+$/.test(normalized)) return normalized;
	return '';
};
